import React, { useState } from 'react';
import '../styles/Certification.css';

const certificationItems = [
  {
    image: 'cert-gf.jpg',
    date: 'June 24, 2025',
    title: 'Green Factory Award',
  },
  {
    image: 'cert-hiem.png',
    date: 'July 12, 2024',
    title: 'Higg Index,Environmental Module',
  },
  {
    image: 'cert-slm.png',
    date: 'July 12, 2024',
    title: 'Higg Index,Social Labour Module',
  },
  {
    image: 'cert-bci.png',
    date: 'November 23, 2021',
    title: 'Better Cotton initiative(BCI)',
  },
  {
    image: 'cert-ocs.png',
    date: 'October 10, 2020',
    title: 'Organic Certificate(OCS)',
  },
  {
    image: 'ocs.png',
    date: 'July 12, 2024',
    title: 'Organic Cotton Standard (OCS)',
  },
];

const ITEMS_TO_DISPLAY = 3;

function Certification() {
  const [startIndex, setStartIndex] = useState(0);

  const nextSlide = () => {
    setStartIndex((prevIndex) =>
      prevIndex + 1 >= certificationItems.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setStartIndex((prevIndex) =>
      prevIndex === 0 ? certificationItems.length - 1 : prevIndex - 1
    );
  };

  const getVisibleItems = () => {
    const items = [];
    for (let i = 0; i < ITEMS_TO_DISPLAY; i++) {
      const index = (startIndex + i) % certificationItems.length;
      items.push(certificationItems[index]);
    }
    return items;
  };

  return (
    <section className="certification-section" id="certifications">
      <div className="certification-header">
        <h2 className="certification-title">OUR PRESTIGIOUS CERTIFICATIONS</h2>
        <div className="certification-nav-buttons">
          <button onClick={prevSlide} className="certification-nav-btn">&larr;</button>
          <button onClick={nextSlide} className="certification-nav-btn">&rarr;</button>
        </div>
      </div>

      <div className="certification-grid">
        {getVisibleItems().map((item, idx) => (
          <div className="certification-card" key={idx}>
            <img
              src={require(`../Assets/Images/${item.image}`)}
              alt={item.title}
              className="certification-image"
            />
            <p className="certification-date">{item.date}</p>
            <h3 className="certification-card-title">{item.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Certification;
